<template>
	<ul id="tw-tabs-nav" class="nav nav-pills nav-fill jum-nav">
		<li class="nav-item">
			<router-link class="nav-link jum-nav-link" :class="{'disabled': !userHasAllNeededJuniperPermissions(['view_users'])}" to="/juniper/user-management/users" exact>
				Users
			</router-link>
		</li>
		<li class="nav-item">
			<router-link class="nav-link jum-nav-link" :class="{'disabled': !userHasAllNeededJuniperPermissions(['view_roles'])}" to="/juniper/user-management/user-roles" exact>Roles</router-link>
		</li>
		<li class="nav-item">
			<router-link class="nav-link jum-nav-link" :class="{'disabled': !userHasAllNeededJuniperPermissions(['view_permissions'])}" to="/juniper/user-management/user-permissions" exact>Permissions</router-link>
		</li>
	</ul>
</template>

<script>
	import juniperUserMixin from "@/mixins/juniperUserMixin";
	export default {
		name: 'NavTabs',
		data: () => ({
		}),
        mounted() {
			
        },
        updated() {
			
        },
        computed: {
            
		},
		mixins: [juniperUserMixin]
    }
</script>
<style scoped>
.jum-nav {
	gap: 8px;
}

.jum-nav-link {
	border: 1px solid #dbe3ec;
	background: #f8fafc;
	color: #334155;
	font-weight: 600;
	border-radius: 999px;
	padding: 9px 12px;
}

.jum-nav-link:hover {
	background: #eef2f7;
	border-color: #c3cfde;
	color: #1f2937;
}

.jum-nav-link.disabled {
	opacity: 0.45;
	pointer-events: none;
}

.router-link-exact-active.router-link-active.jum-nav-link {
	background: #2f6fed !important;
	border-color: #2f6fed;
	color: #fff !important;
}
</style>
